import {
  GET_PROMPT_CATEGORY_SUCCESS,
  GET_PROMPT_CATEGORY_FAILED,
  GET_PROMPT_SUBCATEGORY_SUCCESS,
  GET_PROMPT_SUBCATEGORY_FAILED,
  GET_PROMPT_SUCCESS,
  GET_PROMPT_FAILED,
  GET_SINGLE_PROMPT_SUCCESS,
  GET_IMAGE_GENERATION_PROMPTS_LOADING,
  GET_IMAGE_GENERATION_PROMPTS_SUCCESS,
  GET_IMAGE_GENERATION_PROMPTS_FAILURE,
  GET_CAPITOL_DATA_SUCCESS,
  GET_CAPITOL_DATA_FAILURE,
  GET_CAPITOL_CHARACTER_SUCCESS,
  GET_CAPITOL_CHARACTER_FAILURE,
} from '../types/prompt.type'

export const getPromptCategoryAction = () => async (dispatch) => {
  try {
    const resp = await fetch('/api/supabase/get-prompt-category?type=parent', {
      method: 'GET',
    })
    const data = await resp.json()

    dispatch({ type: GET_PROMPT_CATEGORY_SUCCESS, payload: data })
  } catch (err) {
    dispatch({ type: GET_PROMPT_CATEGORY_FAILED, payload: err?.response?.data })
  }
}

export const getPromptSubCategoryAction = () => async (dispatch) => {
  try {
    const resp = await fetch('/api/supabase/get-prompt-category', {
      method: 'GET',
    })
    const data = await resp.json()
    const result = Object.groupBy(data, ({ parent_id }) => parent_id)

    dispatch({ type: GET_PROMPT_SUBCATEGORY_SUCCESS, payload: result })
  } catch (err) {
    dispatch({ type: GET_PROMPT_SUBCATEGORY_FAILED, payload: err?.response?.data })
  }
}

export const getPromptAction = (category_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_PROMPT_SUCCESS, payload: { loader: false } })
    const resp = await fetch('/api/supabase/get-prompts?id=' + category_id, {
      method: 'GET',
    })
    const data = await resp.json()
    const result = Object.groupBy(data, ({ category_title }) => category_title)
    if (category_id) {
      dispatch({ type: GET_SINGLE_PROMPT_SUCCESS, payload: result })
    } else {
      dispatch({ type: GET_PROMPT_SUCCESS, payload: result })
    }
  } catch (err) {
    dispatch({ type: GET_PROMPT_FAILED, payload: err?.response?.data })
  }
}

export const getCapitolAction = () => async (dispatch) => {
  try {
    const response = await fetch('/api/supabase/get-capitol-prompts', {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error('Failed to get the Capitol prompts')
    }
    const data = await response.json()
    dispatch({ type: GET_CAPITOL_DATA_SUCCESS, payload: data })
  } catch (err) {
    console.error('Error:', err.message)
    dispatch({ type: GET_CAPITOL_DATA_FAILURE, payload: err.message })
  }
}

export const getCapitolCharacter = () => async (dispatch) => {
  try {
    const response = await fetch('/api/supabase/get-capitol-characters', {
      method: 'GET',
    })
    if (!response.ok) {
      throw new Error('Failed to get the Capitol prompts')
    }
    const data = await response.json()
    dispatch({ type: GET_CAPITOL_CHARACTER_SUCCESS, payload: data })
  } catch (err) {
    console.error('Error:', err.message)
    dispatch({ type: GET_CAPITOL_CHARACTER_FAILURE, payload: err.message })
  }
}

export const updateLike = (userID, promptID, type) => async (dispatch) => {
  try {
    const response = await fetch('/api/supabase/updatevote-prompts', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userID: userID, promptID: promptID, type: type }),
    })
    if (!response.ok) {
      throw new Error('Failed to get like the news')
    }
    const data = await response.json()
    return data
  } catch (err) {
    console.error('Error:', err.message)
  }
}

export const fetchtextToImagePrompts = () => async (dispatch) => {
  try {
    dispatch({ type: GET_IMAGE_GENERATION_PROMPTS_LOADING })
    const resp = await fetch('/api/supabase/fetch-text-to-image-prompts', {
      method: 'GET',
    })
    const data = await resp.json()
    const result = Object.groupBy(data, ({ category }) => category)
    if (result) {
      dispatch({ type: GET_IMAGE_GENERATION_PROMPTS_SUCCESS, payload: result })
    }
  } catch (err) {
    dispatch({ type: GET_IMAGE_GENERATION_PROMPTS_FAILURE, payload: err?.response?.data })
  }
}
